









































import Vue from 'vue';
import { ThumbnailViewModel } from '@/types';
import Toast from '@/classes/SnotifyConfiguration';
import { DocumentConstants } from '@/types/constants';

export default Vue.extend({
  name: 'MStoreThumbnailView',
  props: {
    thumbnail: {
      type: Object as () => ThumbnailViewModel | undefined,
      required: true
    },
    maximumImageHeight: {
      type: Number,
      required: false,
      default: 110
    },
    resizeThumbnailContainers: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      imageWidth: null,
      imageHeight: null,
      hoveringOverError: false,
      imageLoaded: false,
      imageStyled: false
    };
  },
  methods: {
    onImageLoaded(this: any) {
      const image = this.$refs['image-' + this.thumbnail.page] as HTMLImageElement;
      this.naturalImageWidth = image?.naturalWidth;
      this.imageWidth = image?.width;
      this.imageHeight = image?.height;
      this.imageLoaded = true;
      this.$emit('imageloaded');
    },
    onErrorClick(this: any) {
      Toast.showError(this.thumbnail.notification);
    },
    onErrorMouseEnter(this: any) {
      this.hoveringOverError = true;
    },
    onErrorMouseLeave(this: any) {
      this.hoveringOverError = false;
    },
    getRotationValue(this: any, rotation: string) {
      switch (rotation) {
        case 'Rotate90': {
          return 90;
        }
        case 'Rotate180': {
          return 180;
        }
        case 'Rotate270': {
          return 270;
        }
        default: {
          return 0;
        }
      }
    }
  },
  computed: {
    isLoading(this: any): boolean {
      return !this.thumbnail?.documentData && !this.thumbnail?.hasNotification;
    },
    hasError(this: any): boolean {
      return this.thumbnail?.hasNotification ?? false;
    },
    pageLabel() {
      return this.thumbnail?.page ?? '';
    },
    thumbnailImageWidth(this: any) {
      return this.naturalImageWidth ?? 0;
    },
    placeholderStyle(): string {
      return `height: ${this.maximumImageHeight}px`;
    },
    errorStyle(this: any): string {
      return this.hoveringOverError ? 'cursor: pointer' : '';
    },
    aSeriesPaperAspectRatio() {
      return DocumentConstants.ASeriesPaperAspectRatio;
    },
    imageStyles(this: any): string {
      if (
        !this.thumbnail ||
        !this.thumbnail.documentPagePreference ||
        !this.imageHeight ||
        !this.imageWidth ||
        !this.thumbnail.documentPagePreference.rotation ||
        this.getRotationValue(this.thumbnail.documentPagePreference.rotation) === 0
      ) {
        return '';
      }

      let translateValue = '';
      let scaleValue = '';
      let transformOrigin = '';
      if (this.getRotationValue(this.thumbnail.documentPagePreference.rotation) === 90) {
        translateValue = `translate(0,-100%)`;
        scaleValue = `scale(calc(${this.imageWidth} / ${this.imageHeight}))`;
        transformOrigin = ' transform-origin : top left;';
      } else if (this.getRotationValue(this.thumbnail.documentPagePreference.rotation) === 270) {
        translateValue = `translate(-100%,0)`;
        scaleValue = `scale(calc(${this.imageWidth} / ${this.imageHeight}))`;
        transformOrigin = ' transform-origin : top left;';
      }
      this.imageStyled = true;
      return `
        transform: rotate(${
          this.thumbnail.documentPagePreference != null ? this.getRotationValue(this.thumbnail.documentPagePreference.rotation) : 0
        }deg) ${scaleValue} ${translateValue}; ${transformOrigin}`;
    },
    imageContainerStyles(this: any): string {
      this.resizeThumbnailContainers; // tslint:disable-line no-unused-expression
      if (
        this.thumbnail &&
        this.thumbnail.documentPagePreference != null &&
        this.thumbnail.documentPagePreference.rotation &&
        this.getRotationValue(this.thumbnail.documentPagePreference.rotation) % 180 === 90 &&
        this.imageLoaded &&
        this.imageStyled
      ) {
        const image = this.$refs['image-' + (this.thumbnail.page ?? '')] as HTMLImageElement;
        if (image && image.width && image.height) {
          const height = image.width * (image.width / image.height);
          return `height : ${height}px`;
        }
      }
      return '';
    }
  }
});
